import { FC, memo } from 'react'

import { cn } from '@hap/components'

import { Avatar } from './avatar'

interface AvatarStackMember {
  firstName?: string
  lastName?: string
  avatarFileId?: string | null
}

interface AvatarStackProps {
  /** Members to display avatars for */
  members: AvatarStackMember[]
  /** Total member count (used for the "+N" overflow indicator) */
  total: number
  /** Maximum number of avatars to render before showing overflow (default: 5) */
  max?: number
  className?: string
}

export const AvatarStack: FC<AvatarStackProps> = memo(
  ({ members, total, max = 5, className }) => {
    const visible = members?.slice(0, max) ?? []
    const overflow = total - visible.length

    if (total === 0) return null

    return (
      <div className={cn('flex items-center -space-x-2', className)}>
        {visible.map((member, index) => (
          <Avatar
            key={index}
            firstName={member.firstName}
            lastName={member.lastName}
            avatarFileId={member.avatarFileId}
            size="sm"
            className="ring-background ring-2"
          />
        ))}
        {overflow > 0 && (
          <span className="bg-accent text-accent-foreground ring-background z-10 flex h-[23px] min-w-[23px] items-center justify-center rounded-full px-1 text-[9px] font-semibold ring-2">
            +{overflow}
          </span>
        )}
      </div>
    )
  },
)
